import '../../platform.css';
import './scouting.css';

import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { navigationPropsState } from '../../recoil/atoms/navigationPropsState';
import { scoutingConfigState } from '../../recoil/atoms/scoutingConfigState';
import { useSetNavigationProps } from '../../recoil/hooks/useSetNavigationProps';
import { useOpenGlobalModal } from '../../recoil/hooks/useOpenGlobalModal';

import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import NotificationsIcon from '@mui/icons-material/Notifications';

import { FixedTabs } from '../../components/controls/navigation/FixedTabs';
import { PlayerScouting } from './playerScouting/PlayerScouting';
import { SeasonScouting } from './seasonScouting/SeasonScouting';
import { Alerts } from './alerts/Alerts';


export const playerTablePageSize = 25;
export const playerTableChapterSize = 4;

export const playerSeasonTablePageSize = 50;
export const playerSeasonTableChapterSize = 1;

export const alertTablePageSize = 50;

export const playerSimpleTablePageSize = 50;
export const playerSimpleTableChapterSize = 4;


const tabOptions = [
  'playerSearch',
  'seasonSearch',
  'alerts'
];

const tabIcons = [
  <PersonSearchIcon key={'person-search-icon'} style={{ fontSize: 21 }} />,
  <QueryStatsIcon key={'query-stats-icon'} style={{ fontSize: 21 }} />,
  <NotificationsIcon key={'notifications-icon'} style={{ fontSize: 21 }} />
];


export const Scouting: React.FC = () => {

  const scoutingConfig = useRecoilValue(scoutingConfigState);

  const { openConfirmModal } = useOpenGlobalModal();

  const navigationProps = useRecoilValue(navigationPropsState);
  const activeSubTab = navigationProps.activeScoutingSubTab ?? 'playerSearch';
  const activeSubTabIndex = useMemo(() => tabOptions.indexOf(activeSubTab), [activeSubTab]);
  const updateNavigationProps = useSetNavigationProps();
  const setActiveSubTab = (subTab: number) => {
    updateNavigationProps({ activeScoutingSubTab: tabOptions[subTab] }, true);
  };


  const openConfirmLeaveAlertModal = (subTab: number) => {
    openConfirmModal(
      () => setActiveSubTab(subTab),
      'exitAlert?',
      'exitAlertInfo'
    );
  };


  const handleSubTabClick = (subTab: number) => {
    if (navigationProps.alertHasUnsavedChanges) {
      openConfirmLeaveAlertModal(subTab);
    }
    else {
      setActiveSubTab(subTab);
    }
  };


  const numberOfNewPlayersSinceLastViewed = scoutingConfig.alerts
    ? scoutingConfig.alerts.reduce((acc, alert) => acc + alert.numberOfNewPlayersSinceLastViewed, 0)
    : 0;


  return (
    <div className='platform-view-section'>

      <FixedTabs
        tabOptions={tabOptions}
        activeTab={activeSubTabIndex}
        setActiveTab={handleSubTabClick}
        parentTab={'scouting'}
        tabIcons={tabIcons}
        numberOfNewPlayersSinceLastViewed={numberOfNewPlayersSinceLastViewed}
      />

      <div className='platform-view-content-container-with-tabs scouting-view-content-container'>
        {activeSubTab === 'playerSearch' && <PlayerScouting />}

        {activeSubTab === 'seasonSearch' && <SeasonScouting />}

        {activeSubTab === 'alerts' && <Alerts />}
      </div>

    </div >
  );
};
